/* ==========================================================================
   LE LINÉAIRE — les flèches, et rien d'autre.

   Le défilement, l'accrochage et le débordement sont faits par le CSS. Ce
   fichier ne sert qu'à donner un équivalent souris au geste du doigt : sans
   lui la section reste entièrement utilisable, ce qui est la condition pour
   qu'une application tierce cassant le JS ne casse pas la page.
   ========================================================================== */
(function () {
  'use strict';

  /* Une même section peut être posée trois fois sur la page d'accueil, donc la
     balise <script> l'est aussi. Un seul moteur suffit. */
  if (window.nmLineairePret) return;
  window.nmLineairePret = true;

  /* Tolérance de sous-pixel : à cause du zoom navigateur et des largeurs en vw,
     scrollLeft n'atteint jamais exactement 0 ni exactement le maximum. Sans
     cette marge, la flèche de fin ne se désactive pas sur un écran sur trois. */
  var EPS = 2;

  function mouvementReduit() {
    return (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      document.documentElement.getAttribute('data-nm-motion') === 'off'
    );
  }

  function monter(section) {
    if (section.dataset.linPret === '1') return;

    var rail = section.querySelector('[data-lin-rail]');
    var nav = section.querySelector('[data-lin-nav]');
    var prec = section.querySelector('[data-lin-prec]');
    var suiv = section.querySelector('[data-lin-suiv]');
    if (!rail || !nav || !prec || !suiv) return;

    section.dataset.linPret = '1';

    /* Le pas est la largeur réelle d'un casier, mesurée, jamais devinée : les
       colonnes sont en vw et changent à chaque point de rupture. */
    function pas() {
      var casier = rail.firstElementChild;
      var gouttiere = parseFloat(getComputedStyle(rail).columnGap) || 0;
      if (!casier) return rail.clientWidth;
      return casier.getBoundingClientRect().width + gouttiere;
    }

    /* On avance d'un nombre ENTIER de casiers : un demi-casier laissé au bord
       désaligne les points d'accrochage et le rail se remet en place tout seul
       juste après le clic, ce qui donne l'impression d'un bug. */
    function bond() {
      var p = pas();
      var tient = Math.floor((rail.clientWidth + EPS) / p);
      return Math.max(1, tient) * p;
    }

    function majEtat() {
      var course = rail.scrollWidth - rail.clientWidth;
      /* Rail plus court que sa fenêtre : il n'y a rien à faire défiler, les
         flèches n'ont pas lieu d'exister. */
      nav.hidden = course <= EPS;
      if (nav.hidden) return;
      var x = Math.abs(rail.scrollLeft); /* abs : en RTL scrollLeft est négatif */
      prec.disabled = x <= EPS;
      suiv.disabled = x >= course - EPS;
    }

    function pousser(sens) {
      var delta = bond() * sens;
      /* Le sens de lecture inverse le signe : on suit la direction calculée
         par le navigateur plutôt que de coder « droite = plus ». */
      if (getComputedStyle(rail).direction === 'rtl') delta = -delta;
      rail.scrollBy({
        left: delta,
        behavior: mouvementReduit() ? 'auto' : 'smooth'
      });
    }

    prec.addEventListener('click', function () { pousser(-1); });
    suiv.addEventListener('click', function () { pousser(1); });

    /* Un rAF par salve : l'événement scroll part à chaque image pendant un
       geste au trackpad, et deux écritures de `disabled` par image suffisent à
       faire tomber le défilement en dessous de 60 images par seconde. */
    var attente = false;
    rail.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      requestAnimationFrame(function () {
        attente = false;
        majEtat();
      });
    }, { passive: true });

    if ('ResizeObserver' in window) {
      /* Observe le rail ET son premier casier : la largeur de colonne change
         aux points de rupture sans que la largeur du rail bouge (colonne en
         vw, rail en 100 %), et le bond serait alors calculé faux. */
      var ro = new ResizeObserver(majEtat);
      ro.observe(rail);
      if (rail.firstElementChild) ro.observe(rail.firstElementChild);
    } else {
      window.addEventListener('resize', majEtat);
    }

    /* Les images arrivent en différé et changent la hauteur, pas la largeur —
       mais les polices, elles, changent la largeur des réglettes. Une seule
       remesure après chargement complet évite un état de flèche faux. */
    if (document.readyState !== 'complete') {
      window.addEventListener('load', majEtat, { once: true });
    }

    majEtat();
  }

  function monterTout(racine) {
    var portee = racine && racine.querySelectorAll ? racine : document;
    if (portee.matches && portee.matches('[data-lineaire]')) monter(portee);
    var trouves = portee.querySelectorAll('[data-lineaire]');
    for (var i = 0; i < trouves.length; i++) monter(trouves[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { monterTout(document); });
  } else {
    monterTout(document);
  }

  /* Obligatoire sur Shopify : une section rechargée dans l'éditeur est un
     nouveau DOM. Sans ce raccrochage, le marchand voit des flèches mortes et
     croit son thème cassé. */
  document.addEventListener('shopify:section:load', function (e) { monterTout(e.target); });
  document.addEventListener('shopify:section:select', function (e) { monterTout(e.target); });
})();
